import React, { Component } from 'react';

class Provider extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { children } = this.props;
        return (
            <div className={this.props.draggable ? "root-provider root-provider-unselect" : "root-provider"}>
                { children }
            </div>
        )
    }
}

export default Provider;